module.exports = __webpack_public_path__ + "img/title-bg.ffeb40fe.png";